import styled from 'styled-components';
import Header from './components/Header'; 
import Blog from './components/Blog';


import './App.css';

const Body = styled.div`
color: white;
text-align: center;
background-color: rgba(0,0,0,.3);

`;


function App() {
  return ( <>
    
      <Header />
      <Blog>
        
      </Blog>
    </>
  );
}

export default App;
